module.exports = __webpack_public_path__ + "img/brand-value-1.20dad82c.png";